import { useGateValue } from '@statsig/react-bindings';

export default function useUsaOnly() {
  return useGateValue('usa_only');
}
